export default "__VITE_ASSET__DuOs06Um__"